export enum FlowOptions {
  SearchDocument = 'flowSearchDocument',
  SearchAddress = 'flowSearchAddress',
}

export default FlowOptions;
